module.exports = __webpack_public_path__ + "static/media/andri2k.278a9bfd.svg";